// extracted by mini-css-extract-plugin
export default {"tx":"_8c47248cfe","line":"c6391c2433"};